import { fetchParentCampaign } from 'api/queries';

import { GraphQLCampaign } from '../domainTypes';
import { useGraphql } from 'utils/hooks/useGraphql';

type QueryResponse = {
  campaign: GraphQLCampaign;
};

export function useParentCampaign(id: number | undefined) {
  const { data, refetch, isLoading, error } = useGraphql<QueryResponse>(fetchParentCampaign, {
    variables: { campaignId: id },
    skip: !id,
  });

  return {
    parentCampaign: data?.campaign,
    fetch: (campaignId?: number) => {
      if (campaignId) {
        refetch({
          campaignId,
        });
      }
    },
    isLoading,
    error,
  };
}
